import React, { useContext, useEffect } from "react";
import { ctxAlertMessage } from "./AlertMessageContext";
import { getAlertClass, getAlertIcon } from "./AlertUtils";
import {CloseSquareDuotoneLine} from "@components/icons/CloseSquareDuotoneLine";

export const AlertMessage: React.FC = () => {
  const { resetAlert, alert } = useContext(ctxAlertMessage);

  useEffect(() => {
    const timer = setTimeout(() => {
      resetAlert();
    }, 3000);

    return () => clearTimeout(timer);
  }, [alert.show]);

  const handleClose = () => {
    resetAlert();
  };

  const alertClass = getAlertClass(alert.type);
  const alertIcon = getAlertIcon(alert.type);

  return alert.show ? (
    <div
      data-testid="alertmessage-overlay"
      className={`fixed bottom-5 z-[999] mx-auto left-0 right-0 w-[400px] rounded-xl p-3 shadow-lg animate-slideUp ${alertClass}`}
      role="alertmessage"
      aria-live="assertive"
    >
      <div className="flex items-center justify-between">
        <p className="text-white font-semibold flex items-center">
          {alertIcon && alertIcon}
          <span className="pl-3">{alert.description}</span>
        </p>
        <div className="flex items-center">
          <div className="w-[1px] h-[20px] bg-white opacity-50"></div>
          <button
            onClick={handleClose}
            className="opacity-70 hover:opacity-100"
          >
            <CloseSquareDuotoneLine className="ml-2 text-white " />
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div />
  );
};
